import React from 'react'
import HomeScreen from './screens/HomeScreen'
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom'
import Maintanence from './components/Maintanence/Maintanence'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route path="/maintanence">
          <Maintanence />
        </Route>
        <Route exact path="/">
          <HomeScreen />
        </Route>
      </Switch>
    </Router>
  )
}

export default App
